export const TERMS_CONDITIONS_PATH = "/about/terms-and-conditions/";

export const DATA_PRIVACY_CHARTER_PATH = "/data-privacy-charter/";

export const PROFILE_PATH = "/profile/";

export const GET_STARTED_PATH = "/get-started-confirmation";

export const REGISTRATION_PATH = "/registration";
export const BEFORE_YOU_GO_PATH = "/before-you-go";
export const MEMBERSHIP = "/membership"; // renewal path
export const PRODUCT = "/product"; // product path

export const MASTER_PRODUCTS_DISPLAY_ORDER: Record<string, number> = {
  traveller: 0,
  explorer: 1,
  "explorer plus": 2,
  discovery: 3,
};
